import { FC } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { LanguageSelector } from "./LanguageSelector";
import { IconProfile } from "@/components/navbar/svg/IconProfile";
import { ButtonMui } from "../button/ButtonMui";
import * as Styled from "./menu.styles";

const sxToggleButtonGroupe = {
  gap: "5px",

  "& .MuiToggleButton-root": {
    color: "var(--on-surface-dark)",

    padding: "0",

    "&.Mui-selected": {
      color: "var(--on-surface-dark)",
      fontWeight: "600 !important",
    },
  },
};

interface MenuLargeProps {
  theme?: string;
}

export const MenuLarge: FC<MenuLargeProps> = ({ theme }) => {
  const router = useRouter();

  return (
    <Styled.MenuLargeContainer>
      <Styled.SelectorContainer theme={theme}>
        {/* <h1
          className={`body-small ${
            router.pathname === "/freetrial" ? "weight-medium" : ""
          }`}
        >
          <Link href="/freetrial">Free trial</Link>
        </h1> */}
        <h1
          className={`body-small ${
            router.pathname === "/contact" ? "weight-medium" : ""
          }`}
        >
          <Link href="/contact">Contact</Link>
        </h1>
      </Styled.SelectorContainer>
      {/* <LanguageSelector theme={theme} selectorStyle={sxToggleButtonGroupe} /> */}
      <Styled.ButtonContainer>
        <ButtonMui
          size="medium"
          variant="text"
          color={theme === "dark" ? "secondary" : "primary"}
          startIcon={<IconProfile theme={theme} />}
          className="animate__animated animate__fadeIn"
        >
          <a
            href="https://app.cellectenergy.com/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Login
          </a>
        </ButtonMui>
        <ButtonMui
          size="medium"
          className="animate__animated animate__fadeIn"
          variant="contained"
          color={theme === "dark" ? "secondary" : "primary"}
        >
          <Link href="/freetrial">Start a free trial</Link>
        </ButtonMui>
      </Styled.ButtonContainer>
    </Styled.MenuLargeContainer>
  );
};
